import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import React, { Component } from 'react';

import { getFechaOfDate, getFechaOfDateMonth, getFechaOfDateV2 } from "../../controller/utils";


export default class MyDocument extends Component {
    constructor(props) {
        super(props);
    }

    styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#fff'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        },
        backgroundImg: {
            position: 'absolute',
            left: 0,
            top: 0
        },
        centerImage: {
            alignItems: "center",
            flexGrow: 1
        },
        image: {
            padding: 0,
            width: '100%',
            position: 'absolute',
            left: 0
        },
        imagePosition: (left, right, top, size, size2) => {
            return {
                left: left ? `${left}` : 'auto',
                right: right ? `${right}` : 'auto',
                top: top ? `${top}` : 'auto', // 175
                width: size ? size : '50%',
                height: size2 ? size2 : '50%',
                position: 'absolute'
            };
        },
        fontText: (left, right, top, size) => {
            return {
                left: left ? `${left}` : 'auto',
                right: right ? `${right}` : 'auto',
                top: top ? `${top}` : 'auto', // 175
                fontSize: size ? size : 9,
                position: 'absolute',
                fontWeight: 'bold'
            };
        },

    });
    fontSize(cadena) {
        return cadena.length > 60 ? 5
            : cadena.length > 50 ? 6 : cadena.length > 40 ? 7 : 8;
    };
    fontSizeM(cadena) {
        return cadena.length > 60 ? 4 : cadena.length > 50 ? 5
            : cadena.length > 40 ? 6 : cadena.length > 30 ? 7 : 8;
    };

    fontSizeA(cadena) {
        return cadena.length > 55 ? 2 : cadena.length > 41 ? 3 : cadena.length > 32 ? 4 : cadena.length > 25 ? 5
            : cadena.length > 21 ? 6 : cadena.length > 19 ? 7 : 8;
    };

    fontSizeCortar(cadena) {
        return cadena.length > 23 ? cadena.slice(0, 23) : cadena;
    };



    render() {
        const { data } = this.props;
        const principal = data.stepPrincipal.afiliacionEmpresas;
        const registro = data.step0.datosinicio;
        const contacto = data.step1.datospersonaladmin ? data.step1.datospersonaladmin : [];
        const empleador = data.step2.datosempleador;
        const empleadorAsk = data.step2.ubicacionempleadorask;
        const ubicacion = data.step3.ubicacionempleador;
        const ubicacionAlt = data.step3.ubicacionempleadoraltern ? data.step3.ubicacionempleadoraltern : {};
        const ubicacionCont = data.step3.ubicacionempleadorcontact;
        const representante = data.step4.datosrepresentante;
        const refeBarcode = data.refeBarcode;

        let posTypeCompany = 25;
        if (empleador.companyClass === "2")
            posTypeCompany = 78;
        if (empleador.companyClass === "3")
            posTypeCompany = 131;

        let activityEconomic = [];
        if (registro.economicActivityStart)
            activityEconomic = registro.economicActivityStart.split(" ");


        //primera position personal contact


        return (
            <React.Fragment>
                <Document>
                    <Page size="A4" style={this.styles.page} >
                        <View style={this.styles.section} >
                            <Image style={this.styles.image} src="/PreAfiliacionEmpresa.jpg" />
                            {refeBarcode ? <Image style={this.styles.imagePosition(412, false, 8, '110px', '28px')} src={`https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${refeBarcode}`} /> : ""}

                            {/* <Text style={this.styles.fontText(410, false, 20, 9)}>{empleador.processNumber ?" empleador.processNumber" : ""}</Text> */}
                            <Text style={principal.empleadorTypeCompany === "1" ? this.styles.fontText(25, false, 67, 9) : principal.empleadorTypeCompany === "2" ? this.styles.fontText(92, false, 67, 9) : this.styles.fontText(157, false, 67, 9)}>x</Text>
                            <Text style={this.styles.fontText(false, 217, 67, 9)}>x</Text>
                            <Text style={registro.typeIdCompanyStart === 'NI' ? this.styles.fontText(25, false, 90, 9) : registro.typeIdCompanyStart === 'CC' ? this.styles.fontText(57, false, 90, 9) : this.styles.fontText(89, false, 90, 9)}>x</Text>
                            <Text style={this.styles.fontText(117, false, 91, 8)}>{registro.checkNumberStart}</Text>
                            <Text style={this.styles.fontText(285, false, 91, 8)}>{registro.employerNameStart.toUpperCase()}</Text>
                            <Text style={this.styles.fontText(posTypeCompany, false, 113, 9)}>{empleador.companyClass ? "x" : ""}</Text>
                            <Text style={this.styles.fontText(167, false, 111, 8)}>{empleador.startOperation ? getFechaOfDateV2(empleador.startOperation) : ""}</Text>
                            <Text style={this.styles.fontText(253, false, 113, 8)}>{activityEconomic.length > 0 ? activityEconomic[0] : ""}</Text>
                            <Text style={this.styles.fontText(315, false, 116, 6.5)}>{empleador.payrollMonth ? empleador.payrollMonth : ""}</Text>
                            <Text style={this.styles.fontText(393, false, 116, 6.5)}>{empleador.employedNumber ? empleador.employedNumber : ""}</Text>
                            <Text style={this.styles.fontText(480, false, 111, 6.5)}>{empleador.contributionPeriod ? getFechaOfDateMonth(empleador.contributionPeriod) : ""}</Text>

                            <Text style={this.styles.fontText(25, false, 137, 7)}>{ubicacion.addressCompany ? ubicacion.addressCompany.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(250, false, 137, 7)}>{ubicacion.hoodCompany ? ubicacion.hoodCompany.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(353, false, 137, 7)}>{ubicacion.cityCompany ? ubicacion.cityCompany.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(448, false, 137, 7)}>{ubicacion.departamentCompany ? ubicacion.departamentCompany.toUpperCase() : ""}</Text>

                            <Text style={this.styles.fontText(25, false, 161, 7)}>{ubicacionAlt.addressCompanyAlternate ? ubicacionAlt.addressCompanyAlternate.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(250, false, 161, 7)}>{ubicacionAlt.hoodCompanyAlternate ? ubicacionAlt.hoodCompanyAlternate.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(353, false, 161, 7)}>{ubicacionAlt.cityCompanyAlternate ? ubicacionAlt.cityCompanyAlternate.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(448, false, 161, 7)}>{ubicacionAlt.departamentCompanyAlternate ? ubicacionAlt.departamentCompanyAlternate.toUpperCase() : ""}</Text>

                            <Text style={this.styles.fontText(25, false, 184, 7)}>{ubicacionCont?.phoneCompany ? ubicacionCont.phoneCompany : ""}</Text>
                            <Text style={this.styles.fontText(110, false, 184, 7)}>{ubicacionCont?.smartPhoneCompany ? ubicacionCont.smartPhoneCompany : ""}</Text>
                            <Text style={this.styles.fontText(25, false, 207, 7)}>{ubicacionCont?.webSite ? ubicacionCont.webSite : ""}</Text>

                            <Text style={this.styles.fontText(220, false, 184, 7)}>{registro.emailCompanyStart ? registro.emailCompanyStart : ""}</Text>
                            <Text style={this.styles.fontText(empleadorAsk.empleadorCajaAsk === "1" ? 295 : 322, false, 204, 9)}>x</Text>
                            <Text style={this.styles.fontText(373, false, 207, 7)}>{empleadorAsk.empleadorCajaRta ? empleadorAsk.empleadorCajaAsk === "1" ? empleadorAsk.empleadorCajaRta : "" : ""}</Text>

                            <Text style={this.styles.fontText(representante.typeId === "CC" ? 25 : representante.typeId === "CE" ? 57 : 90, false, 241, 9)}>x</Text>
                            <Text style={this.styles.fontText(121, false, 243, 7)}>{representante.firstLastname ? representante.firstLastname.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(227, false, 243, 7)}>{representante.secondLastname ? representante.secondLastname.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(333, false, 243, 7)}>{representante.firstName ? representante.firstName.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(442, false, 243, 7)}>{representante.secondName ? representante.secondName.toUpperCase() : ""}</Text>
                            <Text style={this.styles.fontText(25, false, 265, 7)}>{representante.numberId ? representante.numberId : ""}</Text>
                            <Text style={this.styles.fontText(130, false, 265, 7)}>{representante.smartPhoneBoss ? representante.smartPhoneBoss : ""}</Text>
                            <Text style={this.styles.fontText(243, false, 262, 6.5)}>{representante.birthDate ? getFechaOfDate(representante.birthDate) : ""}</Text>
                            <Text style={this.styles.fontText(333, false, 266, 5)}>{representante.jobBoss ? representante.jobBoss.toUpperCase() : ""}</Text>

                            <Text style={this.styles.fontText(75, false, 597, 10)}>{"{{BigSig_es_:signer1:signature:dimension(width=50mm, height=10.5mm):align(center)}}"}</Text>

                            {/* <Text style={this.styles.fontText(400, false, 680, 10)}>{"FTO-GCO-AFC-08 V1"}</Text> */}


                            {

                                contacto.map((post, i) => {
                                    if (i < 4) {
                                        const postuRow = 310 + (20 * i);

                                        let id = `${post.typeIdStaff ? post.typeIdStaff : ""} ${post.numberIdStaff ? post.numberIdStaff : ""}`;
                                        let name = `${post.firstNameStaff ? post.firstNameStaff.toUpperCase() : ""} ${post.secondNameStaff ? post.secondNameStaff.toUpperCase() : ""} ${post.firstLastnameStaff ? post.firstLastnameStaff.toUpperCase() : ""} ${post.secondLastnameStaff ? post.secondLastnameStaff.toUpperCase() : ""}`

                                        return (
                                            <React.Fragment>
                                                <Text style={this.styles.fontText(25, false, postuRow, 7)}>{id}</Text>
                                                <Text style={this.styles.fontText(150, false, postuRow, 7)}>{name}</Text>
                                                <Text style={this.styles.fontText(330, false, postuRow, 5)}>{this.fontSizeCortar(post.jobBossStaff.toUpperCase())}</Text>
                                                <Text style={this.styles.fontText(408, false, postuRow, 6)}>{post.emailStaff}</Text>
                                            </React.Fragment>
                                        )

                                    }
                                })

                            }

                        </View>

                    </Page>
                </Document>
            </React.Fragment>
        );
    }
}



